import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_property_key } from "@swc/helpers/_/_to_property_key";
import { CREDIT_CARD_FEES_PAID_BY } from '~/types/api/drafts-search';
import { isAgreementSettingsEmpty, isPaymentSettingsEmpty } from '../../settings-predicates';
const dayBound = (range)=>{
    var _ref, _ref1, _ref2, _ref3, _ref4, _range_gt;
    var _range_in;
    return (_ref = (_ref1 = (_ref2 = (_ref3 = (_ref4 = (_range_gt = range.gt) !== null && _range_gt !== void 0 ? _range_gt : range.gte) !== null && _ref4 !== void 0 ? _ref4 : range.lte) !== null && _ref3 !== void 0 ? _ref3 : range.lt) !== null && _ref2 !== void 0 ? _ref2 : range.eq) !== null && _ref1 !== void 0 ? _ref1 : (_range_in = range.in) === null || _range_in === void 0 ? void 0 : _range_in[0]) !== null && _ref !== void 0 ? _ref : null;
};
export const expirationIsNever = (predicate)=>{
    var _ref;
    var _predicate_type;
    return ((_ref = (_predicate_type = predicate.type) === null || _predicate_type === void 0 ? void 0 : _predicate_type.in) !== null && _ref !== void 0 ? _ref : []).includes('none');
};
const expirationValueLabel = (predicate, t)=>{
    var _ref;
    var _predicate_type;
    const types = (_ref = (_predicate_type = predicate.type) === null || _predicate_type === void 0 ? void 0 : _predicate_type.in) !== null && _ref !== void 0 ? _ref : [];
    if (types.includes('none')) return t.settingsExpirationNeverLabel();
    if (predicate.days != null) {
        const days = dayBound(predicate.days);
        if (days != null && (predicate.days.lte != null || predicate.days.lt != null)) {
            return t.settingsExpirationWithin({
                days
            });
        }
        if (days != null && (predicate.days.gt != null || predicate.days.gte != null)) {
            return t.settingsExpirationAfter({
                days
            });
        }
        if (days != null) return t.settingsExpirationIn({
            days
        });
    }
    if (types.includes('days')) return t.settingsExpirationSet();
    return t.settingsValueSet();
};
const approvalValueLabel = (predicate, t)=>{
    var _ref;
    var _predicate_type, _predicate_auto;
    const types = (_ref = (_predicate_type = predicate.type) === null || _predicate_type === void 0 ? void 0 : _predicate_type.in) !== null && _ref !== void 0 ? _ref : [];
    if (types.includes('manual')) return t.settingsApprovalManual();
    const autoDays = ((_predicate_auto = predicate.auto) === null || _predicate_auto === void 0 ? void 0 : _predicate_auto.days) != null ? dayBound(predicate.auto.days) : null;
    if (autoDays != null) return t.settingsApprovalAutoAfter({
        days: autoDays
    });
    if (types.includes('auto') || predicate.auto != null) return t.settingsApprovalAuto();
    return t.settingsValueSet();
};
const amendmentsApprovalValueLabel = (predicate, t)=>{
    var _ref;
    var _predicate_type, _predicate_auto;
    const types = (_ref = (_predicate_type = predicate.type) === null || _predicate_type === void 0 ? void 0 : _predicate_type.in) !== null && _ref !== void 0 ? _ref : [];
    if (types.includes('manual')) return t.settingsApprovalApprovedManual();
    const autoDays = ((_predicate_auto = predicate.auto) === null || _predicate_auto === void 0 ? void 0 : _predicate_auto.days) != null ? dayBound(predicate.auto.days) : null;
    if (autoDays != null) return t.settingsApprovalApprovedAutoAfter({
        days: autoDays
    });
    if (types.includes('auto') || predicate.auto != null) return t.settingsApprovalApprovedAuto();
    return t.settingsValueSet();
};
const compactPayment = (next)=>isPaymentSettingsEmpty(next) ? undefined : next;
const compactAgreement = (next)=>isAgreementSettingsEmpty(next) ? undefined : next;
export const removePaymentField = (settings, field)=>{
    const { [field]: _omitted } = settings, rest = _object_without_properties(settings, [
        _to_property_key(field)
    ]);
    return compactPayment(rest);
};
export const setRequirePaymentMethod = (settings, value)=>compactPayment(_object_spread_props(_object_spread({}, settings), {
        requirePaymentMethod: value
    }));
export const setCreditCardFees = (settings, value)=>{
    const { creditCardFeesPaidBy: _omitted } = settings, rest = _object_without_properties(settings, [
        "creditCardFeesPaidBy"
    ]);
    return compactPayment(value == null ? rest : _object_spread_props(_object_spread({}, rest), {
        creditCardFeesPaidBy: value
    }));
};
export const removeAgreementField = (settings, field)=>{
    const { [field]: _omitted } = settings, rest = _object_without_properties(settings, [
        _to_property_key(field)
    ]);
    return compactAgreement(rest);
};
export const setTermsName = (settings, input)=>compactAgreement(_object_spread_props(_object_spread({}, settings), {
        termsOfService: _object_spread_props(_object_spread({}, settings.termsOfService), {
            name: {
                contains: input
            }
        })
    }));
export const creditCardFeesFrom = (selected)=>CREDIT_CARD_FEES_PAID_BY.filter((value)=>selected.includes(value));
export const creditCardFeesLabel = (value, t)=>value === 'client' ? t.settingsCcFeesPaidByClient() : t.settingsCcFeesPaidByServiceProvider();
export const residualAgreementDescriptors = (settings, onChange, t)=>{
    const descriptors = [];
    if (settings.expirationDate != null) {
        descriptors.push({
            field: 'expirationDate',
            fieldLabel: expirationIsNever(settings.expirationDate) ? '' : t.settingsExpirationDateLabel(),
            valueLabel: expirationValueLabel(settings.expirationDate, t),
            onRemove: ()=>onChange(removeAgreementField(settings, 'expirationDate'))
        });
    }
    if (settings.amendmentsApprovalMethod != null) {
        descriptors.push({
            field: 'amendmentsApprovalMethod',
            fieldLabel: t.settingsAmendmentsFieldLabel(),
            valueLabel: amendmentsApprovalValueLabel(settings.amendmentsApprovalMethod, t),
            onRemove: ()=>onChange(removeAgreementField(settings, 'amendmentsApprovalMethod'))
        });
    }
    if (settings.outOfScopeChargesApprovalMethod != null) {
        descriptors.push({
            field: 'outOfScopeChargesApprovalMethod',
            fieldLabel: t.settingsOosApprovalLabel(),
            valueLabel: approvalValueLabel(settings.outOfScopeChargesApprovalMethod, t),
            onRemove: ()=>onChange(removeAgreementField(settings, 'outOfScopeChargesApprovalMethod'))
        });
    }
    return descriptors;
};
export const creditCardFeesSelection = (param)=>{
    let { settings, next } = param;
    const values = creditCardFeesFrom(next.selected);
    if (values.length === 0) return setCreditCardFees(settings, undefined);
    return setCreditCardFees(settings, next.operator === 'exclude' ? {
        nin: values
    } : {
        in: values
    });
};
export const termsNameFromInput = (settings, input)=>input === '' ? removeAgreementField(settings, 'termsOfService') : setTermsName(settings, input);
